import React from "react";
import * as styles from './section-alternate-grid.module.scss';
import Img from 'gatsby-image';
import { RichText } from "../../components/Layout/RichText/RichText";
import { useLocalPath } from "../../hooks";
import { Link } from "gatsby"
const SectionAlternateGrid = ({
    position,
    sectionContent,
    sectionImage,
    title,
    type,
    buttonText,
    buttonSlug
}: {
    position?: String,
    sectionContent: any,
    sectionImage: any,
    title?: any,
    type: String
}) => {
    const category = type.toLocaleLowerCase()
    const extraClass = position ? position.toLocaleLowerCase() : 'left'


    if (category === 'default') {
        return (
            <div className={styles.articles}>
                <div className={`${styles.articleContainer} ${styles[extraClass]}`}>
                    <div className={styles.wrapper}>
                        <div className={`styles.image`}>
                            <Img fluid={sectionImage.fluid} alt={sectionImage.title} />
                        </div>
                    </div>
                    <div className={styles.wrapperText}>
                        <p><strong>{title}</strong></p>
                        {
                            sectionContent &&
                            <RichText content={sectionContent} />
                        }
                    </div>
                </div>
            </div>
        )
    }
    else if (category === 'purposepage') {
        const sectionTitle = title && title.split(',')
        return (
            <>
                {
                    sectionTitle &&
                    <div className={`${styles.purposeTitle} underline-heading`}>
                        {
                            sectionTitle.map((title) => {
                                return (
                                    <p>{title}</p>
                                )
                            })
                        }
                    </div>
                }
                <div className={styles.articlesPurpose}>
                    <div className={`${styles.articleContainer} ${styles[extraClass]}`}>
                        <div className={styles.wrapper}>
                            <div className={`styles.image`}>
                                <Img fluid={sectionImage.fluid} alt={sectionImage.title} />
                            </div>
                        </div>
                        <div className={styles.wrapperText}>
                            {
                                sectionContent &&
                                <RichText content={sectionContent} />
                            }
                        </div>
                    </div>
                </div>
            </>
        )
    }
    else if (category === 'comment') {
        return (
            <div className={styles.articlesComment}>
                <div className={`${styles.articleContainer} ${styles[extraClass]}`}>
                    <div className={styles.wrapper}>
                        <div className={`styles.image`}>
                            <Img fluid={sectionImage.fluid} alt={sectionImage.title} />
                        </div>
                    </div>
                    <div className={styles.wrapperText}>
                        <p><strong>{title}</strong></p>
                        {
                            sectionContent &&
                            <RichText content={sectionContent} />
                        }
                    </div>
                </div>
            </div>
        )
    }
    if (category === 'iconsize') {
        return (
            <div className={styles.iconSize}>
                <div className={`${styles.articleContainer} ${styles[extraClass]}`}>
                    <div className={styles.iconImage}>
                        <div className={`styles.image`}>
                            <Img fluid={sectionImage.fluid} alt={sectionImage.title} />
                        </div>
                    </div>
                    <div className={styles.iconText}>
                        <p><strong>{title}</strong></p>
                        {
                            sectionContent &&
                            <RichText content={sectionContent} />
                        }
                    </div>
                </div>
            </div>
        )
    }
    if (category === 'fullcartus') {
        return (
            <div className={styles.gridSection}>
                <div className={`${styles.sectionContainer} ${styles[extraClass]}`}>
                    <div className={styles.wrapperSection}>
                        <div className={`styles.image`}>
                            <Img fluid={sectionImage.fluid} alt={sectionImage.title} />
                        </div>
                    </div>
                    <div className={styles.sectionText}>
                        <p><strong>{title}</strong></p>
                        {
                            sectionContent &&
                            <RichText content={sectionContent} />
                        }
                        {buttonText && buttonSlug && (
                            <Link to={useLocalPath(buttonSlug)} className={`btn-primary ${styles.btnPrimary}`}>
                                {buttonText}
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        )
    }
    if (category === 'alignedimage') {
        return (
            <div className={styles.mainDiv}>
                <div className={styles.imgDiv}>
                    <Img className={`styles.img`} fluid={sectionImage.fluid} alt={sectionImage.title} />
                </div>

                <div className={styles.contentDiv}>
                    {title && <p className={styles.heading}>{title}</p>}

                    <div className={styles.descContent}>
                        {sectionContent &&
                            <RichText content={sectionContent} />
                        }
                    </div>
                </div>

            </div>
        )
    }
    if (category === 'jusfiedcentered') {
        return (
            <div className={styles.parentDiv}>
                <div className={styles.imgSection}>
                    <Img fluid={sectionImage.fluid} alt={sectionImage.title} />
                </div>

                <div className={styles.content_section}>
                    {title && <p className={styles.heading}>{title}</p>}

                    <div className={styles.descContentOne}>
                        {sectionContent &&
                            <RichText content={sectionContent} />
                        }
                    </div>
                    {buttonText && buttonSlug && (
                        <div className={styles.learMore}>
                            <Link to={useLocalPath(buttonSlug)} className={`btn-primary ${styles.btnPrimary}`}>
                                {buttonText}
                            </Link>
                        </div>
                    )}
                </div>

            </div>
        )
    }
     if (category === 'centered') {
        return (
            <div className={styles.mainDivOne}>
                <div className={styles.imgDivOne}>
                    <Img fluid={sectionImage.fluid} alt={sectionImage.title} />
                </div>

                <div className={styles.content_section}>
                    {title && <p className={styles.heading}>{title}</p>}

                    <div className={styles.descContentOne}>
                        {sectionContent &&
                            <RichText content={sectionContent} />
                        }
                    </div>
                </div>

            </div>
        )
    }

}

export default SectionAlternateGrid